var Camera2DView = function (model, editorView) {
    var self = this;

    this.model = model;
    this.editorView = editorView;

    this.zoom_stuff = {};
    this.zoom_stuff["viewX"] = this.model.viewX();
    this.zoom_stuff["viewY"] = this.model.viewY();
    this.zoom_stuff["viewS"] = this.model.viewS();

    self.model.viewX.onChange('view', function(){
        self.setView();
    },10);

    self.model.viewY.onChange('view', function(){
        self.setView();
    },10);

    self.model.viewS.onChange('view', function(){
        self.setView();
    },10);
};

module.exports = Camera2DView;

Camera2DView.prototype.setView = function() {

    var x = this.model.viewX();
    var y = this.model.viewY();
    var s = this.model.viewS();

    this.editorView.svg.change(this.editorView.zoomGroup, {
        'transform' : ' scale(' + s + ',' + -s + ') translate(' + x + ',' + -y + ')'
    });

    if(Camera2DView.DEBUG) {
        if(this.model.getBoundingBox()) {
            var attrs = {fill: "yellow", opacity:0.1};
            this.editorView.svg.rect(this.editorView.zoomGroup, this.model.getBoundingBox().x, this.model.getBoundingBox().y,
                this.model.getBoundingBox().width, this.model.getBoundingBox().height, attrs);
        }
    }

    this.zoom_stuff["viewX"] = x;
    this.zoom_stuff["viewY"] = y;
    this.zoom_stuff["viewS"] = s;
};

Camera2DView.DEBUG = false;
